import { Dialog, makeStyles } from '@material-ui/core';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import MaterialTable from 'material-table';
import React, { useEffect, useState } from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import { useHistory } from "react-router";
import { toast } from 'react-toastify';
import { CommonUrl, logoutMsg, myHeaderStyle, mySearchFieldStyle, NONCE, processMsg, TIME_STAMP } from '../../../common-url/CommonUrl';
import FirmwareFileForm from '../component/FirmwareFileForm';


const useStyles = makeStyles(theme => ({
    root: {
        /*  "& .MuiPaper-root": {
            borderBottom: "none",
            backgroundColor:"transparent",
            boxShadow:"none" 
          },*/
        "& .MuiInput-underline:before": {
            borderBottom: 0,
        },
        "& .MuiInput-underline:after": {
            borderBottom: 0,
        },
        "& .MuiInput-root": {
            borderBottom: 0,
        },
        "&:last-child td": {
            // borderBottom: 0,
        },
    }
}));

export default function FirmwareFileList() {

    const encToken = useSelector(({ auth }) => auth.authToken, shallowEqual);
    const [firmware, setFirmware] = useState([]);
    const classes = useStyles();
    const history = useHistory();

    const columns = [
        { title: "Sr No", render: rowData => rowData.tableData.id + 1 },
        { title: "Title", field: "vTitle" },
        { title: "Description", field: "vDescription" },
        {
            title: "Product Group", field: "vProductGroup",
            lookup: {
                "smartack": "SmarTack",
                "smartouch_4M": "SmarTouch 4M",
                "smartouch_8M": "SmarTouch 8M",
                "smartap_1_15A": "SmarTap 15A",
                "smartap_1_5A": "SmarTap 5A",
                "smartap_4M": "SmarTap 4M",
                "smartap_8M": "SmarTap 8M",

            },
        },
        { title: "Firmware Version", field: "vVersion" },
        { title: "File Name", field: "vFileName" },
        {
            title: "Stauts", field: "tiStatus",
            lookup: { 0: 'Inactive', 1: 'Active' },
            render: (rowData) => <div className={rowData.tiStatus ? "text-success " : "text-danger"}>{rowData.tiStatus ? "Active" : "Inactive"}</div>
        },
    ]

    // ------------------------------------------------------------
    //                          initial loading
    // ------------------------------------------------------------
    const myTextIcon = React.useRef(null);

    useEffect(() => {
        fetchFW();
        myTextIcon.current.parentNode.parentNode.classList.remove('MuiIconButton-root');

    }, [])
    const fetchFW = () => {
        fetch(CommonUrl.firmwareBaseUrl + "/view", {
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'token': encToken,
                'nonce': NONCE,
                'timestamp': TIME_STAMP
            }
        }).then(response => response.json())
            .then(response => {
                if (response.code == 401) {
                    history.push("/logout");
                    toast.info(logoutMsg, { autoClose: 5000 })
                } else {
                    setFirmware(response.data)
                }
            });
    }

    // ------------------------------------------------------------
    //                          delete
    // ------------------------------------------------------------

    const handleDelete = (oldData) => {
        const id = toast.loading(processMsg)
        fetch(CommonUrl.firmwareBaseUrl + "/delete", {
            method: "delete",
            body: JSON.stringify({
                _id: oldData._id,
                vFileName: oldData.vFileName
            }),
            headers: {
                'Content-Type': 'application/json',
                'token': encToken,
                'nonce': NONCE,
                'timestamp': TIME_STAMP
            }
        }).then(response => response.json()).then(response => {
            if (response.code === 200) {
                toast.update(id, { render: response.message, type: "success", isLoading: false, autoClose: 3000 })
                fetchFW();
            } else {
                toast.update(id, { render: response.message, type: "error", isLoading: false, autoClose: 3000 })
            }
        })
    }

    // ---------------------------------------------------------------------
    //                           manage form
    // ---------------------------------------------------------------------
    const [openForm, setOpenForm] = useState(false)
    const [formData, setFormData] = useState({})
    const addFirmwareFile = () => {
        setOpenForm(true)
    }
    const handleUpdateForm = (rowData) => {
        setFormData(rowData)
        setOpenForm(true)
    }
    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenForm(false);
        setTimeout(() => {
            setFormData({})
        }, 200);
    };

    return (
        <div className="App">
            <Dialog
                open={openForm}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description">
                <FirmwareFileForm data={formData} firmware={firmware} ></FirmwareFileForm>
            </Dialog>
            {/* material table starts */}
            <div className={classes.root} >
                <MaterialTable title="Firmware Details"
                    style={{ paddingInline: "30px", paddingTop: "10px" }}
                    data={firmware}
                    columns={columns}
                    editable={{
                        onRowDelete: oldData => new Promise((resolve, reject) => {
                            handleDelete(oldData)
                            resolve();
                        }),
                    }}
                    actions={[
                        {
                            icon: () => <div ref={myTextIcon}><button className="btn btn-light-primary mx-6">Add +</button></div>,
                            iconProps: { color: "secondary" },
                            tooltip: 'Add FW',
                            isFreeAction: true,
                            onClick: () => {
                                addFirmwareFile()
                            }
                        },
                        {
                            icon: 'edit',
                            tooltip: 'Update FW',
                            iconProps: { color: "secondary" },
                            // isFreeAction: true,
                            onClick: (e, rowData) => {
                                handleUpdateForm(rowData)
                            }
                        }
                    ]}
                    icons={{
                        Delete: () => <DeleteOutlineIcon style={{ color: "#f64e60" }} />
                    }}
                    onRowClick={(evt, rowData) => { handleUpdateForm(rowData) }}
                    options={{
                        filtering: false,
                        actionsColumnIndex: -1,
                        addRowPosition: "first",
                        headerStyle: myHeaderStyle,
                        searchFieldStyle: mySearchFieldStyle,
                        emptyRowsWhenPaging: false, // To avoid of having empty rows
                    }}
                />
            </div>
            {/* material table ends */}
        </div>
    )
}
